/*@flow*/
import type { Element } from 'react';
import React, { useState, useContext } from 'react';
import geolocate from 'lib/geolocate';
import Present from 'lib/Present';
import commands from './commands';
import context from './context';

export default (props: {
  isLocating?: boolean,
  errors?: string[],
}): Element<'a'> => {
  const [isLocating, setLocating] = useState(Boolean(props.isLocating));
  const [errors, setErrors] = useState(props.errors || []);
  const ctx = useContext(context);

  const locateUser = () => {
    if (isLocating) return;
    setLocating(true);
    setErrors([]);
    geolocate()
      .then((latlon) => {
        setTimeout(() => setLocating(false), 400);
        const [lat, lon] = latlon || [];
        if (!lat || !lon) return;
        commands(ctx).setLocation(latlon);
      })
      .catch((err) => {
        setLocating(false);
        setErrors(Array.isArray(err) ? err : [err]);
      });
  };

  const txt = isLocating ? 'Locating...' : 'Locate Me';
  let style: {
    color?: string,
    cursor: string,
    textDecoration?: string,
  } = isLocating
    ? { cursor: 'default', textDecoration: 'none', color: '#ccc' }
    : { cursor: 'pointer' };

  if (Present.is(errors)) {
    style.color = 'red';
  }

  return (
    <a
      style={{ color: '#999', ...style }}
      disabled={isLocating}
      onClick={locateUser}
      data-testid="LocateMeButton"
    >
      <i className="fa fa-bullseye" /> {txt}
    </a>
  );
};
